// extracted by mini-css-extract-plugin
module.exports = {"button-with-tooltip":"CommentsWorkReportApproverButton_button-with-tooltip__2bBJT","container":"CommentsWorkReportApproverButton_container__3sKYd"};